/**
 * Pure helpers behind QuoteView's tab strip and header profit, kept out of the
 * component file so they can be unit-tested (and so the component module only
 * exports components).
 */
// hasDataValidation = the Data validation screen (Feature 34, Lead Gen) —
// the AI-Extraction tab goes with it. hasPricingTab = the store runs the legacy
// quote pricing workflow (useQuoteProductPricing).
export const buildTabs = (
  basePath,
  isMerchant,
  requestType,
  hasDataValidation = true,
  hasPricingTab = true
) => {
  const baseTabs = [{ label: "Details", link: `${basePath}` }];

  if (hasPricingTab) {
    baseTabs.push({ label: "Pricing", link: `${basePath}/pricing` });
  }

  if (!isMerchant) {
    if (hasDataValidation) {
      baseTabs.push({
        label: "AI-Extraction",
        link: `${basePath}/ai-extraction`,
      });
    }

    if (requestType === "sell") {
      baseTabs.push({ label: "Leads", link: `${basePath}/leads` });
    }

    baseTabs.push({ label: "Activity", link: `${basePath}/activity` });
  }

  return baseTabs;
};

export const activeTabFn = (pathname, tab, tabs) => {
  const tabName = pathname.split("/").pop();

  // Only the tabs this quote actually has — a link to a hidden tab (an old
  // `/pricing` URL on a store without the Pricing tab) lands on Details
  // instead of an empty panel.
  const subTabs = (tabs || []).slice(1).map((t) => t.link.split("/").pop());

  if (!subTabs.includes(tabName)) {
    return tab?.label === tabs?.[0].label;
  }

  return tab?.label?.toLowerCase().indexOf(tabName) > -1;
};

// Tabs are looked up by label, never by position: which tabs exist depends on
// the store (Pricing), the plan (AI-Extraction) and the request type (Leads),
// so a fixed index shows one tab's content under another's heading.
export const findTab = (tabs, label) => tabs.find((t) => t.label === label);

// Stores without PRODUCT PRICING record an order's buying price on the
// listing (Internal Details & Costs). GET /api/quotes/{id} returns that
// listing, so the header's Profit / Net Profit read it from there.
const listingBuy = (quote) =>
  quote?.listing?.buying_price
    ? {
        buy: quote.listing.buying_price,
        buyCurrency: quote.listing.buying_currency || "gbp",
      }
    : {};

export const getProfitPrices = (quote, prices, hasProductPricing = true) => {
  if (!quote) {
    return {};
  }

  if (quote.type === "sell") {
    return {
      buy: quote?.price,
      buyCurrency: quote?.currency || "gbp",
      trade: quote?.trade_avg || prices?.trade,
      market: quote?.market_avg || prices?.market,
      // trade_avg/market_avg are ALWAYS GBP: they're seeded from
      // trade.month.gbp / market.month.gbp (and persisted from the same). So
      // the FX base for these medians is gbp — NetProfit/Profit then convert
      // gbp → buyCurrency via useFx. (Do not carry averages.currency here: the
      // medians are GBP magnitudes regardless of the deal currency.)
      avgCurrency: "gbp",
    };
  }

  const buySide =
    hasProductPricing || quote.product_price
      ? {
          buy: quote.product_price?.price,
          buyCurrency: quote.product_price?.currency,
        }
      : listingBuy(quote);

  return {
    ...buySide,
    sell: quote.price,
    sellCurrency: quote.currency || "gbp",
  };
};
